export default "__VITE_ASSET__659351bf__"